import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';
import {
  consumeLogoutRedirectPath,
  peekLogoutRedirectPath,
  peekRequireCredentialReauth
} from '../utils/authSession';
import { isPublicAppPath } from '../utils/publicRoutes';

const RequireAuth = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (isPublicAppPath(location.pathname)) {
    return children;
  }

  // Signed-out screens can still have a lingering Firebase session while the
  // user is asked to re-enter credentials. Do not let nav send them back in.
  if (peekRequireCredentialReauth()) {
    const logoutRedirect = peekLogoutRedirectPath();
    return (
      <Navigate
        to={logoutRedirect || '/login'}
        state={{
          from: location,
          signedOut: !logoutRedirect
        }}
        replace
      />
    );
  }

  // Keep the authenticated tree mounted during mid-session token refresh so pages
  // (e.g. Drop-In visit detail) are not remounted when auth briefly sets loading.
  if (loading && !currentUser) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  if (!auth.currentUser && !currentUser) {
    const logoutRedirect = consumeLogoutRedirectPath();
    return (
      <Navigate
        to={logoutRedirect || '/login'}
        state={{
          from: location,
          signedOut: !logoutRedirect
        }}
        replace
      />
    );
  }

  return children;
};

export default RequireAuth;
